/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11 6H12H13M15.5 6H16V6C17.1046 6 18 6.89543 18 8V8V8.5M6 8.5V8V8C6 6.89543 6.89543 6 8 6V6H8.5M6 11V12V13M6 15.6V16V16C6 17.1046 6.89543 18 8 18V18H8.5M11 18H12H13M15.5 18H16V18C17.1046 18 18 17.1046 18 16V16V15.5M18 13V12V11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M11 6H12H13M6 11V12V13M11 18H12H13M18 13V12V11M15.5 18H16V18C17.1046 18 18 17.1046 18 16V16V15.5M8.5 18H8V18C6.89543 18 6 17.1046 6 16V16V15.6M6 8.5V8V8C6 6.89543 6.89543 6 8 6V6H8.5M15.5 6H16V6C17.1046 6 18 6.89543 18 8V8V8.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM6.75 8C6.75 7.30964 7.30964 6.75 8 6.75H8.5C8.91421 6.75 9.25 6.41421 9.25 6C9.25 5.58579 8.91421 5.25 8.5 5.25H8C6.48122 5.25 5.25 6.48122 5.25 8V8.5C5.25 8.91421 5.58579 9.25 6 9.25C6.41421 9.25 6.75 8.91421 6.75 8.5V8ZM11 5.25C10.5858 5.25 10.25 5.58579 10.25 6C10.25 6.41421 10.5858 6.75 11 6.75H12H13C13.4142 6.75 13.75 6.41421 13.75 6C13.75 5.58579 13.4142 5.25 13 5.25H12H11ZM15.5 5.25C15.0858 5.25 14.75 5.58579 14.75 6C14.75 6.41421 15.0858 6.75 15.5 6.75H16C16.6904 6.75 17.25 7.30964 17.25 8V8.5C17.25 8.91421 17.5858 9.25 18 9.25C18.4142 9.25 18.75 8.91421 18.75 8.5V8C18.75 6.48122 17.5188 5.25 16 5.25H15.5ZM6.75 11C6.75 10.5858 6.41421 10.25 6 10.25C5.58579 10.25 5.25 10.5858 5.25 11V12V13C5.25 13.4142 5.58579 13.75 6 13.75C6.41421 13.75 6.75 13.4142 6.75 13V12V11ZM18.75 11C18.75 10.5858 18.4142 10.25 18 10.25C17.5858 10.25 17.25 10.5858 17.25 11V12V13C17.25 13.4142 17.5858 13.75 18 13.75C18.4142 13.75 18.75 13.4142 18.75 13V12V11ZM18.75 15.5C18.75 15.0858 18.4142 14.75 18 14.75C17.5858 14.75 17.25 15.0858 17.25 15.5V16C17.25 16.6904 16.6904 17.25 16 17.25H15.5C15.0858 17.25 14.75 17.5858 14.75 18C14.75 18.4142 15.0858 18.75 15.5 18.75H16C17.5188 18.75 18.75 17.5188 18.75 16V15.5ZM6.75 15.6C6.75 15.1858 6.41421 14.85 6 14.85C5.58579 14.85 5.25 15.1858 5.25 15.6V16C5.25 17.5188 6.48122 18.75 8 18.75H8.5C8.91421 18.75 9.25 18.4142 9.25 18C9.25 17.5858 8.91421 17.25 8.5 17.25H8C7.30964 17.25 6.75 16.6904 6.75 16V15.6ZM11 17.25C10.5858 17.25 10.25 17.5858 10.25 18C10.25 18.4142 10.5858 18.75 11 18.75H12H13C13.4142 18.75 13.75 18.4142 13.75 18C13.75 17.5858 13.4142 17.25 13 17.25H12H11Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M11 6H12H13M6 11V12V13M11 18H12H13M18 13V12V11M15.5 18H16V18C17.1046 18 18 17.1046 18 16V16V15.5M8.5 18H8V18C6.89543 18 6 17.1046 6 16V16V15.6M6 8.5V8V8C6 6.89543 6.89543 6 8 6V6H8.5M15.5 6H16V6C17.1046 6 18 6.89543 18 8V8V8.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11 6H12H13M15.5 6H16V6C17.1046 6 18 6.89543 18 8V8V8.5M6 8.5V8V8C6 6.89543 6.89543 6 8 6V6H8.5M6 11V12V13M6 15.6V16V16C6 17.1046 6.89543 18 8 18V18H8.5M11 18H12H13M15.5 18H16V18C17.1046 18 18 17.1046 18 16V16V15.5M18 13V12V11M10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 6.75C7.30964 6.75 6.75 7.30964 6.75 8V8.5C6.75 8.91421 6.41421 9.25 6 9.25C5.58579 9.25 5.25 8.91421 5.25 8.5V8C5.25 6.48122 6.48122 5.25 8 5.25H8.5C8.91421 5.25 9.25 5.58579 9.25 6C9.25 6.41421 8.91421 6.75 8.5 6.75H8ZM10.25 6C10.25 5.58579 10.5858 5.25 11 5.25H12H13C13.4142 5.25 13.75 5.58579 13.75 6C13.75 6.41421 13.4142 6.75 13 6.75H12H11C10.5858 6.75 10.25 6.41421 10.25 6ZM14.75 6C14.75 5.58579 15.0858 5.25 15.5 5.25H16C17.5188 5.25 18.75 6.48122 18.75 8V8.5C18.75 8.91421 18.4142 9.25 18 9.25C17.5858 9.25 17.25 8.91421 17.25 8.5V8C17.25 7.30964 16.6904 6.75 16 6.75H15.5C15.0858 6.75 14.75 6.41421 14.75 6ZM6 10.25C6.41421 10.25 6.75 10.5858 6.75 11V12V13C6.75 13.4142 6.41421 13.75 6 13.75C5.58579 13.75 5.25 13.4142 5.25 13V12V11C5.25 10.5858 5.58579 10.25 6 10.25ZM18 10.25C18.4142 10.25 18.75 10.5858 18.75 11V12V13C18.75 13.4142 18.4142 13.75 18 13.75C17.5858 13.75 17.25 13.4142 17.25 13V12V11C17.25 10.5858 17.5858 10.25 18 10.25ZM18 14.75C18.4142 14.75 18.75 15.0858 18.75 15.5V16C18.75 17.5188 17.5188 18.75 16 18.75H15.5C15.0858 18.75 14.75 18.4142 14.75 18C14.75 17.5858 15.0858 17.25 15.5 17.25H16C16.6904 17.25 17.25 16.6904 17.25 16V15.5C17.25 15.0858 17.5858 14.75 18 14.75ZM6 14.85C6.41421 14.85 6.75 15.1858 6.75 15.6V16C6.75 16.6904 7.30964 17.25 8 17.25H8.5C8.91421 17.25 9.25 17.5858 9.25 18C9.25 18.4142 8.91421 18.75 8.5 18.75H8C6.48122 18.75 5.25 17.5188 5.25 16V15.6C5.25 15.1858 5.58579 14.85 6 14.85ZM10.25 18C10.25 17.5858 10.5858 17.25 11 17.25H12H13C13.4142 17.25 13.75 17.5858 13.75 18C13.75 18.4142 13.4142 18.75 13 18.75H12H11C10.5858 18.75 10.25 18.4142 10.25 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
